import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NotFound from "../extras/NotFound";
import WithNavbar from "../extras/PrivateRouteWithNavbar";
import SalesTable from '../tables/SalesTable';
import CreateSale from "../creation-forms/CreateSale";
import ViewSale from '../view-edit/ViewSale';

export default function Sales() {
    const match = useRouteMatch();
    return (
        <Switch>
            <WithNavbar exact path={match.path} component={SalesTable} />
            <WithNavbar path={`${match.path}/create`} component={CreateSale} />
            <WithNavbar path={`${match.path}/view_:id`} component={ViewSale} />
            <Route path="*" component={NotFound} />
        </Switch>
    )
}